import React from "react";
import i18n from "i18next";
import { Select, MenuItem, SelectChangeEvent } from "@mui/material";
import _ from "underscore";
import { Languages } from "../../shared/language/languages";

const NATIVE_NAMES: Record<string, string> = {
  en: "English",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  jp: "日本語",
  ru: "Русский",
  it: "Italiano",
  cn: "中文",
  kr: "한국어",
  ph: "Filipino",
  in: "हिन्दी",
  sa: "العربية",
  pt: "Português",
  id: "Indonesia",
  se: "Svenska",
  pl: "Polski",
  dn: "Dansk",
  nl: "Nederlands",
  tr: "Türkçe",
};

export default function LanguageSelector() {
  const langs = _.toArray(Languages);
  const currentLang = i18n.language in NATIVE_NAMES ? i18n.language : "en";

  const handleChange = (e: SelectChangeEvent<string>) => {
    i18n.changeLanguage(e.target.value);
  };

  return null;

  return (
    <Select
      value={currentLang}
      onChange={handleChange}
      size="small"
      sx={{
        fontSize: "0.85rem",
        height: 32,
        ".MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0,0,0,0.15)" },
      }}
    >
      {langs.map((lang) => (
        <MenuItem key={lang.id} value={lang.id} sx={{ fontSize: "0.85rem", gap: 0.75 }}>
          {lang.name} {NATIVE_NAMES[lang.id] ?? lang.id}
        </MenuItem>
      ))}
    </Select>
  );
}
